import { Maybe } from 'types/generatedSchemaTypes';
import useOngoingParkingSession from './useOngoingParkingSession';

const useParkingLinkedToCharging = ({
  parkingZoneUid,
}: {
  parkingZoneUid: Maybe<string> | undefined;
}) => {
  const { allParkingSessions } = useOngoingParkingSession();

  const parkingSession = allParkingSessions?.find(
    (parkingSession) => parkingSession?.parkingZoneUid === parkingZoneUid
  );

  const allowStopOngoingParkingSession =
    parkingSession && parkingSession?.type !== 'ANPR';

  return { parkingSession, allowStopOngoingParkingSession };
};

export default useParkingLinkedToCharging;
